import { DriverCategory } from '../types/index.js';

/** Display order for driver category pickers (youngest classes through senior weight class). */
export const DRIVER_CATEGORY_OPTIONS: DriverCategory[] = [
  DriverCategory.KID_KART,
  DriverCategory.CADET,
  DriverCategory.MICRO,
  DriverCategory.MINI,
  DriverCategory.JUNIOR,
  DriverCategory.SENIOR,
  DriverCategory.SENIOR_HEAVY,
  DriverCategory.UNKNOWN,
];

export function formatDriverCategory(category: DriverCategory | string) {
  return category;
}
